import stateWatcher from '../../packs/state';
import {
  getClientByTypes,
  showCity,
  showPlace,
  changeSelectValues,
} from './utils';

export default async function filterLoader() {
  let clientByType = await getClientByTypes();

  function typeWatcher() {
    $('.route-section-select').on('change', (e) => {
      const $elem = $(e.currentTarget);
      const type = $elem.data('type');
      const code = $elem.val();
      const cityTypes = ['delivery_collect', 'depot'];
      if (cityTypes.includes(code)) {
        showCity(type);
      } else {
        showPlace(type);
        changeSelectValues(clientByType, code, type);
      }
    });
  }

  typeWatcher();
}

$(() => {
  stateWatcher('#place1_state_id', '#city-select-place1');
  stateWatcher('#place2_state_id', '#city-select-place2');
  stateWatcher('#place3_state_id', '#city-select-place3');
  filterLoader();
});
